import { render, staticRenderFns } from "./StudentList.vue?vue&type=template&id=18372de0&scoped=true&lang=pug"
import script from "./StudentList.vue?vue&type=script&lang=js"
export * from "./StudentList.vue?vue&type=script&lang=js"
import style0 from "./StudentList.vue?vue&type=style&index=0&id=18372de0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18372de0",
  null
  
)

export default component.exports